import { Button } from "@mui/material";
import DownloadIcon from "@mui/icons-material/Download";
import { downloadCsv } from "../utils/csv-export.js";
import { useSnackbar } from "../utils/index.js";

export default function InfoCsvExportButton({ filename, getRows, disabled = false, children = "Εξαγωγή CSV" }) {
    const { error } = useSnackbar();
    const onClick = () => {
        try { downloadCsv(filename, getRows()); }
        catch { error("Η εξαγωγή CSV δεν ολοκληρώθηκε. Δοκιμάστε ξανά."); }
    };
    return <Button variant="outlined" startIcon={<DownloadIcon />} onClick={onClick} disabled={disabled} sx={{ m: 1 }}>
        {children}
    </Button>;
}
